// Class: haxe.lang.Iterable

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Iterable = function() {}

// Meta

Iterable.__name__ = "haxe.lang.Iterable";
Iterable.__isInterface__ = true;
Iterable.prototype = {
	
};
Iterable.prototype.__class__ = Iterable.prototype.constructor = $hxClasses["haxe.lang.Iterable"] = Iterable;

// Init



// Statics


Iterable.__meta__ = { obj : { SuppressWarnings : ["checkstyle:FieldDocComment"]}}

// Export

exports.default = Iterable;